(function() {
  window.uploadService = {
    uploadFile(data) {
      return axios.post( '/api/upload/file', data, {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      });
    }
  }
})();